module.exports = __webpack_public_path__ + "07171ae94d37400e6d25d134d8168bfd.svg";